<template>
  <div>
    <div class="cooperation_wrap">
        <div class="brain_title">我们的客户</div>
        <div class="brain_desc">70%+客户为生产制造业、央企国企、政府单位、上市公司</div>


      <div class="cooperation_box ">
        <el-row class="card_wrap hidden-xs-only" type="flex">
          <el-col
              class="brain_item"
              :span="8"
              v-for="(item, index) in cardList"
              :key="index"

          >
            <div class="content-div">
            <div class="item_bg"></div>
            <el-row style="z-index: 2">
              <el-col :span="4">
                <img :src="item.src" alt="" class="img_item"/>
              </el-col>
              <el-col :span="20" style="padding-left: 5px">
                <div class="item_title">{{ item.desc }}</div>
                <div class="item_desc">{{ item.title }}</div>
              </el-col>
            </el-row>
            </div>
          </el-col>
        </el-row>
        <el-carousel height="160PX" indicator-position="outside" class="hidden-sm-and-up">
          <el-carousel-item v-for="(item, index) in cardList" :key="index">
            <div class="content-div">
              <div class="item_bg"></div>
              <el-row style="z-index: 2">
                <el-col :span="4">
                  <img :src="item.src" alt="" class="img_item"/>
                </el-col>
                <el-col :span="20" style="padding-left: 5px">
                  <div class="item_title">{{ item.desc }}</div>
                  <div class="item_desc">{{ item.title }}</div>
                </el-col>
              </el-row>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="flex-container">
          <div v-for="(item, index) in customerList" :key="index" class="item">
              <img :src="item.src" width="100%"/>

          </div>
        </div>
      </div>
    </div>
    <div class="cooperation_bottom hidden-xs-only" >
      <div style="width: 70%;margin: auto;text-align: center">
        <div class="brain_title" style="color: #fff">多项资质权威认证  安全可信</div>
        <div class="brain_desc" style="color: #fff;padding-bottom: 20px">尊重每一位企业领航人，您每一份心血都不会辜负</div>
      </div>
      <img :src="rongyuSrc" style="width: 100%"/>
    </div>
    <div class="cooperation_bottom hidden-sm-and-up" >
      <div style="width: 70%;margin: auto;text-align: center">
        <div class="brain_title" style="color: #fff">荣誉资质</div>
        <div class="brain_desc" style="color: #fff;padding-bottom: 20px">权威认证  安全可信</div>
      </div>
      <img src="../../assets/img/mobile/zizhi-title.png" style="width: 50%;margin-bottom: 20px"/>
      <img src="../../assets/img/mobile/zizhi0.png" style="width: 100%;margin-bottom: 20px"/>
      <img src="../../assets/img/mobile/zizhi.png" style="width: 100%;margin-bottom: 20px"/>
      <img src="../../assets/img/mobile/zhuanli-title.png" style="width: 50%;"/>
      <img src="../../assets/img/mobile/zhuanli.png" style="width: 100%;margin-bottom:0px"/>
      <img src="../../assets/img/mobile/zhuanli2.png" style="width: 68%;margin-bottom: 20px"/>
      <img src="../../assets/img/mobile/quanwei-title.png" style="width: 50%"/>
      <img src="../../assets/img/mobile/quanwei.png" style="width: 100%"/>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      currentPage: 0,
      customerList: [
          { src: require('@/assets/img/customer/acgk.png')},
          { src: require('@/assets/img/customer/hngxy.png')},
          { src: require('@/assets/img/customer/ibm.png')},
          { src: require('@/assets/img/customer/hnsjcjt.png')},
          { src: require('@/assets/img/customer/hnsrmjcy.png')},
          { src: require('@/assets/img/customer/hy.png')},
          { src: require('@/assets/img/customer/hhkjjt.png')},
          { src: require('@/assets/img/customer/pyszjrmfy.png')},
          { src: require('@/assets/img/customer/rhzn.png')},
          { src: require('@/assets/img/customer/hnwg.png')},
          { src: require('@/assets/img/customer/hnsxdfw.png')},
          { src: require('@/assets/img/customer/zgdj.png')},
          { src: require('@/assets/img/customer/zglt.png')},
          { src: require('@/assets/img/customer/zkhy.png')},
      ],
      cardList: [
        {
          src: require('@/assets/img/customer/gaoke_mini.png'),
          title: '———安彩高科',
          desc: '助力安彩高科打造工业5.0数智体系，集成物联平台与ERP/MES系统，数据驱动生产优化及资源调配，实现降本增效、质量跃升与全景管控。',
        },
        {
          src: require('@/assets/img/customer/wugang_mini.png'),
          title: '———舞阳钢铁',
          desc: '依托智能监控与容灾备份体系，数据中心运维通过自动化巡检及资源调度，保障企业核心业务连续性与生产零中断，实现资源优化。',
        },
        {
          src: require('@/assets/img/customer/dianjian_mini.png'),
          title: '———中国电建',
          desc: '构建央企总部与分支机构安全通信桥梁，以加密传输、身份认证及访问控制保障数据安全，支撑跨域高效协作与统一管控。',
        },
      ],
      rongyuSrc: require('@/assets/img/home/rongyu.jpg'),

    }
  },
  methods: {
    pageChange(page) {
      this.currentPage = page - 1
    },
  },
}
</script>

<style lang="scss" scoped>
.cooperation_wrap {
  padding-top: 10px;
  width: 100%;
  text-align: center;
  //background: url('../../assets/img/bottom_bg.90c1ea1.jpg') 0 0 no-repeat;
  //background-size: 100% 100%;
  background-color: #fff;
  padding-bottom: 60px;
  @media screen and (max-width: 768px) {
    background-color: #F5F7FA;
  }
  .cooperation_tit {
    font-size: 40px;
    font-weight: bold;
    color: #3e3e3e;
    padding-top: 50px;
    @media screen and (max-width: 768px) {
      font-size: 1.1rem;
    }
  }
  .cooperation_desc {
    color: rgba(32, 48, 64, 0.75);
    font-size: 22px;
    margin-top: 30px;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
    }
  }
  .cooperation_box {
    width: 70%;
    margin: 0 auto;
    padding-top: 40px;
    position: relative;
    @media screen and (max-width: 768px) {
      width: 90%;
    }
  }
  .flex-container {
    margin: 30px 0 10px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start; /* 或者使用 space-between, space-around 等 */
  }

  .item {
    width: calc(100% / 7 - 16px); /* 减去间距 */
    margin: 8px; /* 可根据需要调整 */
    box-sizing: border-box; /* 确保宽度包含padding和border */
    border-radius: 2px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(224, 236, 255, 1);
    box-shadow: 6px 6px 16px 2px rgba(12, 28, 56, 0.05);
    padding: 0 20px;
    @media screen and (max-width: 768px) {
      width: calc(100% / 3 - 10PX); /* 减去间距 */
      margin: 5PX; /* 可根据需要调整 */
      padding: 0 10PX;
      border-radius: 4PX;
    }

  }
}
.cooperation_bottom {
  width: 100%;
  background-color: #05102F;
  @media screen and (max-width: 768px) {
    padding-top: 20PX;
    padding-bottom: 40PX;
    text-align: center;
  }
  .details_show {
    width: 70%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 768px) {
      width: 95%;
      margin: 0 auto;
    }
    .show_item {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .show_top {
        color: #717171;
        font-size: 50px;
        font-weight: bold;
        @media screen and (max-width: 768px) {
          font-size: 16px;
        }
      }

      .show_bottom {
        color: #717171;
        font-size: 25px;
        margin-top: 10px;
        @media screen and (max-width: 768px) {
          font-size: 14px;
        }
      }
    }
  }
}
.brain_title {
  color: #203040;
  font-size: 33px;
  font-weight: bold;
  padding: 40px 0 10px 0;
  @media screen and (max-width: 768px) {
    font-size: 1.1rem;
  }
}
.brain_desc {
  //color: rgba(32, 48, 64, 0.75);
  font-size: 14px;
  letter-spacing: 1px;
  @media screen and (max-width: 768px) {
    font-size: 0.8rem;
    line-height: 30PX;
  }
}
.card_wrap {
  width: 92%;
  flex-wrap: wrap;
  margin: 0 auto;
  justify-content: space-between;
  @media screen and (max-width: 768px) {
    width: 95%;
  }
  .brain_item {
    transition: background-color 1s;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 40PX;
      border-radius: 10PX;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin-top: 20PX;
      &:nth-child(-n+2){
        margin-top: 0;
      }
    }

  }
}
.content-div{
  margin: 0 10px;
  padding: 20px 15px;
  border-radius: 4px;
  border: 2px solid #fff;
  background: linear-gradient(180deg, rgba(235, 237, 245, 1) 0%, rgba(254, 254, 254, 1) 100%);
  box-shadow: 0 0.5rem 1.5rem 0.5rem rgb(12 28 56 / 10%);
  position: relative;
  @media screen and (max-width: 768px) {
    height: 180PX;
    padding: 30PX 30PX;
    box-shadow: unset;
  }
  .img_item {
    margin-top: 10px;
    width: 80% ;
  }
  &:hover{
    box-shadow: 0 0.5rem 1.5rem 0.5rem rgb(12 28 56 / 18%);
  }
  .item_bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(180deg, rgba(235, 237, 245, 1) 0%, rgba(254, 254, 254, 1) 100%);
    //box-shadow: 0 0.5rem 1.5rem 0.5rem rgb(12 28 56 / 12%);
    opacity: 0;
    transition: all 0.5s;
    border-radius: 4px;
    z-index: 1;
    border: 1px solid #fff;
  }
  &:hover .item_bg{
    opacity: 1;
  }
  &:hover .item_title {
    color: #05102F;
  }
  //&:hover .item_desc {
  //  color: #0052D9;
  //}
  .item_title {
    transition: all 0.5s;
    font-size: 13px;
    //line-height: 1.5rem;
    //font-weight: bold;
    color: #203040;
    text-align: left;
    padding: 10px 0 10px 0;
    z-index: 2;
    position: inherit;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      text-align: left;
    }
  }
  .item_desc {
    transition: all 0.5s;
    color: #203040;
    text-align: right;
    line-height: 1.5rem;
    z-index: 2;
    position: inherit;
    font-size: 13px;
    min-height: 30px;
    @media screen and (max-width: 768px) {
      min-height: 30PX;
      font-size: 0.8rem;
      text-indent: 2em;
    }
    i{
      padding: 0 5px 0 8px;
      color: #19B21E;
      font-weight: bold
    }
  }
}
</style>